import { Audience, Bucket, EngagementMetricType } from '../types'
import { GetCollegePremiumInsightsResponse } from './getCollegePremiumInsights'

type GetCollegePremiumInsightsRequest =
  | {
      status: 'idle'
    }
  | {
      status: 'loading'
    }
  | {
      status: 'success'
      data: GetCollegePremiumInsightsResponse
    }
  | {
      status: 'error'
      error: any
    }

export interface PremiumInsightsState {
  selectedFilters: {
    audience: Audience
    bucket: Bucket
  }
  selectedEngagementMetricType: EngagementMetricType
  getCollegePremiumInsightsRequest: GetCollegePremiumInsightsRequest
}

export const INITIAL_STATE: PremiumInsightsState = {
  selectedFilters: {
    audience: 'student',
    bucket: '1y',
  },
  selectedEngagementMetricType: 'count',
  getCollegePremiumInsightsRequest: {
    status: 'idle',
  },
}

export type Action =
  | { type: 'SET_AUDIENCE_FILTER'; payload: { audience: Audience } }
  | { type: 'SET_DATE_RANGE_FILTER'; payload: { bucket: Bucket } }
  | { type: 'GET_COLLEGE_PREMIUM_INSIGHTS_REQUEST'; payload: GetCollegePremiumInsightsRequest }
  | { type: 'SELECT_ENGAGEMENT_METRIC_TYPE'; payload: EngagementMetricType }

export const reducer = (state: PremiumInsightsState, action: Action) => {
  switch (action.type) {
    case 'SET_AUDIENCE_FILTER':
      return {
        ...state,
        selectedFilters: {
          ...state.selectedFilters,
          audience: action.payload.audience,
        },
      }
    case 'SET_DATE_RANGE_FILTER':
      return {
        ...state,
        selectedFilters: {
          ...state.selectedFilters,
          bucket: action.payload.bucket,
        },
      }
    case 'GET_COLLEGE_PREMIUM_INSIGHTS_REQUEST':
      return {
        ...state,
        getCollegePremiumInsightsRequest: action.payload,
      }
    case 'SELECT_ENGAGEMENT_METRIC_TYPE':
      return {
        ...state,
        selectedEngagementMetricType: action.payload,
      }
    default:
      return state
  }
}
